import React, { useRef, useState } from 'react';

// add logic to check file size on change
// const MAX_FILE_SIZE_MB = 5;
const SUPPORTED_FILE_FORMATS = ['png', 'jpg', 'jpeg', 'gif', 'doc'];

export default function FileUpload({
  onRemoveCurrentSelection,
  onFileChange,
  showRequiredMessage,
}: {
  onFileChange: (file: File) => void;
  onRemoveCurrentSelection: () => void;
  showRequiredMessage: boolean;
}): JSX.Element {
  const [selectedDoc, setSelectedDoc] = useState<File>();
  const fileUploadRef = useRef<HTMLInputElement>(null);

  const handleFileChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    if (e.target?.files && e.target.files.length > 0) {
      setSelectedDoc(e.target.files[0]);
      onFileChange(e.target.files[0]);
    }
  };

  const deleteCurrentDocument = (): void => {
    setSelectedDoc(undefined);
    onRemoveCurrentSelection();
  };

  const openFileSelectorModal = (
    event: React.MouseEvent<HTMLAnchorElement>,
  ): void => {
    event.preventDefault();
    // use ref to drill down into hidden file input and fire click event
    fileUploadRef?.current
      ?.querySelector<HTMLInputElement>('.upload-input')
      ?.click();
  };

  return (
    <React.Fragment>
      <div
        className={
          showRequiredMessage
            ? 'border-solid border-2 border-red-500 rounded-md'
            : ''
        }
        // .w-fit does not work
        style={{ width: 'fit-content' }}
      >
        <input
          type='file'
          accept={SUPPORTED_FILE_FORMATS.join(', ')}
          onChange={handleFileChange}
          ref={fileUploadRef}
        />
        {showRequiredMessage && (
          <p className='text-md text-gray-500 text-center'>Required</p>
        )}
      </div>

      {selectedDoc && (
        <div>
          <div
            className={`${
              selectedDoc
                ? 'border-2 border-green-500 shadow'
                : 'border-2 border-red-500'
            } w-full flex items-center justify-between my-2 p-4 bg-white rounded-lg`}
          >
            <div className='flex flex-col'>
              <div className='text-normal'>{selectedDoc?.name}</div>
              <a
                onClick={openFileSelectorModal}
                className='font-bold text-sm text-blue-600 cursor-pointer'
              >
                Replace
              </a>
            </div>
            <span onClick={deleteCurrentDocument} className='cursor-pointer'>
              Pointer Icon
            </span>
          </div>
        </div>
      )}
    </React.Fragment>
  );
}
